import { SCREEN_BREAKPOINT } from '@components/Grid/Grid.style';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { ImgWH } from '@pages/CommonStyle/common.style';

export const SolutionCaseCard = styled.div`
  display: flex;
  flex-direction: row;
  padding: 32px;
  border-radius: 32px;
  background-color: #ffffff3f;
  width: 100%;
  min-width: 0;
  gap: 32px;
  max-width: 50%;

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    max-width: 100%;
    flex-direction: column;
    gap: 16px;
    padding: 24px;
  }
`;

export const SolutionCaseCardText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  min-width: 0;
  align-items: start;
`;

export const CustomerLogoImg = styled.img<{ w: string; h: string }>`
  ${({ w }) => w && `width : ${w}px;`}
  ${({ h }) => h && `height : ${h}px;`}
  border-radius : 16px;
  background-color: #fff;
`;
